import React, { useState, useEffect  } from "react"; // Importing React and useState hook
import Modal from "../../../Common/Modal"; // Importing Modal component
import Popup from "../../../Common/Popup"; // Importing Popup component
import { useGlobal } from "../../../../context/GlobalContextProvider";

// Initial form state for the beneficiary
const initialForm = {
  beneficiary_name: "",
  beneficiary_address: "",
  beneficiary_email: "",
  beneficiary_possessive_name: "",
};

// AddBeneficiary component for adding a new beneficiary
const AddBeneficiary = ({
  setOpenBeneficiary,
  showBeneficiaryPopup,
  setBeneficiary,
}) => {
  const {
    setSpinner, // Function to control the spinner loading state
  } = useGlobal(); // Using custom context

  // Local state to manage form data and validation errors
  const [form, setForm] = useState(initialForm);
  const [errorBeneficiaryName, setErrorBeneficiaryName] = useState(false);
  const [errorBeneficiaryAddress, setErrorBeneficiaryAddress] = useState(false);
  const [errorBeneficiaryEmail, setErrorBeneficiaryEmail] = useState(false);
  const [errorBeneficiaryAddressUnique, setErrorBeneficiaryAddressUnique] = useState(false);
  const [errorBeneficiaryEmailUnique, setErrorBeneficiaryEmailUnique] = useState(false);
  const [errorBeneficiaryNameUnique, setErrorBeneficiaryNameUnique] = useState(false);
  const [errorPossessiveName, setErrorPossessiveName] = useState(false);
  const MAX_CHAR_LIMIT_24 = 24

  //limits chars
  const [charLimitsName, setCharLimitsName] = useState(false);
  const [charLimitsPossesiveName, setCharLimitsPossesiveName] = useState(false);

  // Function to handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "beneficiary_name":
        if (value.length <= MAX_CHAR_LIMIT_24) {
          setCharLimitsName(value.length === MAX_CHAR_LIMIT_24);
          setForm({
            ...form,
            [name]: value,
          });
        }
        break;

      case "beneficiary_possessive_name":
        if (value.length <= MAX_CHAR_LIMIT_24) {
          setCharLimitsPossesiveName(value.length === MAX_CHAR_LIMIT_24);
          setForm({
            ...form,
            [name]: value,
          });
        }
        break;

      default:
        setForm({
          ...form,
          [name]: value,
        });
        break;
    }
  };

  // Function to handle form submission
  const handleSubmit = async () => {
    // Resetting error states before validation
    setErrorBeneficiaryName(false);
    setErrorBeneficiaryAddress(false);
    setErrorBeneficiaryEmail(false);
    setErrorPossessiveName(false);
    setErrorBeneficiaryAddressUnique(false);
    setErrorBeneficiaryEmailUnique(false);
    setErrorBeneficiaryNameUnique(false);

    // Validating required fields
    if (!form.beneficiary_name) setErrorBeneficiaryName(true);
    if (!form.beneficiary_address) setErrorBeneficiaryAddress(true);
    if (!form.beneficiary_email) setErrorBeneficiaryEmail(true);
    if (!form.beneficiary_possessive_name) setErrorPossessiveName(true);

    // Validate character limits - prevent submit if at maximum character limit
    if (charLimitsName || charLimitsPossesiveName) {
      return; // Stop submit if name or possessive name is at X character limit
    }

    // Additional validation for unique fields
    if (
      form.beneficiary_address &&
      form.beneficiary_email &&
      form.beneficiary_name &&
      form.beneficiary_possessive_name
    ) {
      // Making API call to check for unique constraints
      const res_unique = await fetch(`/api/beneficiary/check-unique`, {
        method: "POST",
        body: JSON.stringify({
          beneficiary_address: form.beneficiary_address,
          beneficiary_email: form.beneficiary_email,
          beneficiary_name: form.beneficiary_name
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      });
      setSpinner(true); // Show loading spinner while processing
      if(res_unique.status === 200){
        const isUnique = await res_unique.json();

        // Handling uniqueness response and setting corresponding error states
        if (isUnique.address_exist && isUnique.email_exist && isUnique.name_exist) {
          setErrorBeneficiaryAddressUnique(true);
          setErrorBeneficiaryEmailUnique(true);
          setErrorBeneficiaryNameUnique(true);
        } else if(!isUnique.address_exist && isUnique.email_exist && !isUnique.name_exist){
          setErrorBeneficiaryAddressUnique(false);
          setErrorBeneficiaryEmailUnique(true);
          setErrorBeneficiaryNameUnique(false);
        } else if(!isUnique.address_exist && !isUnique.email_exist && isUnique.name_exist){
          setErrorBeneficiaryAddressUnique(false);
          setErrorBeneficiaryEmailUnique(false);
          setErrorBeneficiaryNameUnique(true);
        } else if(isUnique.address_exist && !isUnique.email_exist && !isUnique.name_exist){
          setErrorBeneficiaryAddressUnique(true);
          setErrorBeneficiaryEmailUnique(false);
          setErrorBeneficiaryNameUnique(false);
        } else if(!isUnique.address_exist && !isUnique.email_exist && !isUnique.name_exist){
          // If all fields are unique, proceed to add the beneficiary
          const res = await fetch(`/api/beneficiary`, {
            method: "POST",
            body: JSON.stringify(form),
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
          });
          const newItem = await res.json();
          // Updating the beneficiary list in the parent component
          setBeneficiary((prevArray) => [...prevArray, newItem]);      
          setOpenBeneficiary(false); // Close the popup
          // Resetting uniqueness error states
          setErrorBeneficiaryAddressUnique(false);
          setErrorBeneficiaryEmailUnique(false);
          setErrorBeneficiaryNameUnique(false);
        }

        setSpinner(false); // Hide loading spinner after processing
      }
    }
  };
  useEffect(() => {
    if (showBeneficiaryPopup) {
      setForm(initialForm);
    }
  }, [showBeneficiaryPopup]);
  return (
    <Modal show={showBeneficiaryPopup}> {/* Modal to show the form */}
      <Popup>
         {/* Botón de cierre en la esquina */}
      <button
        onClick={() => setOpenBeneficiary(false)}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          background: "transparent",
          border: "none",
          fontSize: "25px",
          cursor: "pointer",
        }}
        className="btn-close"
      >
        ✖
      </button>
        {/* Beneficiary name input */}
        <div className="mt-4">
          <label htmlFor="beneficiary_name" className="form-labels">Beneficiary name:</label>
          <input
            type="text"
            name="beneficiary_name" // Input field for beneficiary name
            placeholder=""
            onChange={handleChange} // Handle input change
            value={form.beneficiary_name} // Controlled input value
            className="form-control mt-2 inputs"
            id="beneficiary_name"
            maxLength={MAX_CHAR_LIMIT_24}
          />
          {errorBeneficiaryName ? ( // Error message for beneficiary name
            <span id="errorBeneficiaryName" className="form-text text-danger">
              Beneficiary name is required
            </span>
          ) : (
            <span></span>
          )}
          {errorBeneficiaryNameUnique ? ( // Error message for duplicate name
            <span
              id="errorBeneficiaryNameUnique"
              className="form-text text-danger"
            >
              Name is already used
            </span>
          ) : (
            <span></span>
          )}
          {charLimitsName && (
            <span className="form-text text-danger">
              Maximum character limit reached
            </span>
          )}
        </div>
        
        {/* Beneficiary possessive name input */}
        <div className="mt-4">
          <label htmlFor="beneficiary_possessive_name" className="form-labels">Beneficiary name (possessive):</label>
          <input
            type="text"
            name="beneficiary_possessive_name" // Input field for beneficiary possessive name
            placeholder=""
            onChange={handleChange} // Handle input change
            value={form.beneficiary_possessive_name} // Controlled input value
            className="form-control mt-2 inputs"
            id="beneficiary_possessive_name"
            maxLength={MAX_CHAR_LIMIT_24}
          />
          {errorPossessiveName ? ( // Error message for possessive name
            <span id="errorPossessiveName" className="form-text text-danger">
              Possessive name is required
            </span>
          ) : (
            <span></span>
          )}
          {charLimitsPossesiveName && (
            <span className="form-text text-danger">
              Maximum character limit reached
            </span>
          )}
        </div>

        {/* Beneficiary email input */}
        <div className="mt-4">
          <label htmlFor="beneficiary_email" className="form-labels">Beneficiary Email:</label>
          <input
            type="text"
            name="beneficiary_email" // Input field for beneficiary email
            placeholder=""
            onChange={handleChange} // Handle input change
            value={form.beneficiary_email} // Controlled input value
            className="form-control mt-2 inputs"
            id="beneficiary_email"
          />
          {errorBeneficiaryEmail ? ( // Error message for email
            <span id="errorBeneficiaryEmail" className="form-text text-danger">
              Beneficiary email is required
            </span>
          ) : (
            <span></span>
          )}
          {errorBeneficiaryEmailUnique ? ( // Error message for duplicate email
            <span
              id="errorBeneficiaryAddressUnique"
              className="form-text text-danger"
            >
              Email is already used
            </span>
          ) : (
            <span></span>
          )}
        </div>

        {/* Beneficiary payment address input */}
        <div className="mt-4">
          <label htmlFor="beneficiary_address" className="form-labels">Payment Address:</label>
          <input
            type="text"
            name="beneficiary_address" // Input field for beneficiary address
            id="beneficiary_address"
            placeholder=""
            onChange={handleChange} // Handle input change
            value={form.beneficiary_address} // Controlled input value
            className="form-control mt-2 inputs"
          />
          {errorBeneficiaryAddress ? ( // Error message for address
            <span
              id="errorBeneficiaryAddress"
              className="form-text text-danger"
            >
              Payment Address is required
            </span>
          ) : (
            <span></span>
          )}
          {errorBeneficiaryAddressUnique ? ( // Error message for duplicate address
            <span
              id="errorBeneficiaryAddressUnique"
              className="form-text text-danger"
            >
              Payment Address is already used
            </span>
          ) : (
            <span></span>
          )}
        </div>

        {/* Submit button */}
        <button
          type="button"
          onClick={handleSubmit} // Handle form submission
          className="btn bg-orange form-btn mt-4"
        >
          Add Beneficiary
        </button>
      </Popup>
    </Modal>
  );
};

export default AddBeneficiary; // Exporting the component for use in other parts of the application
